import React, { useEffect } from 'react'
import styled from 'styled-components'
import { ReactComponent as QuickChatIcon } from "../../Assets/icons/quickChat/QuickChatIcon.svg";

import { ReactComponent as New } from "../../Assets/icons/newChatIcon.svg";
import { useQuickChatService } from '../../Context/QuickChatContext';
import { isMobile, isSafari } from 'react-device-detect';
import { useTranslate } from '@tolgee/react';
import PrimaryButton from '../GenericComponents/PrimaryButton';


const QuickChatHeader = ({ onClick }) => {

    const { t } = useTranslate();
    const { quickChat } = useQuickChatService();

    let registerText = t('quick_chat.register_text');
    if (isMobile) {
        registerText = t('quick_chat.register_text_mobile');
    }

    return (
        <Container onClick={onClick} id='qc-header'  >
            <QuickChatIcon />
            <QcName>
                {quickChat?.quick_chat_name}
            </QcName>
            <PrimaryButton
                style={{ marginLeft: "auto" }}
                onClick={(e) => window.open("https://7jkwc.app.link/redirect-quick-chats")}
                iconLeft={<New />}
                text={registerText}
            >

            </PrimaryButton>
        </Container>
    )
}

export default QuickChatHeader

const Container = styled.div`
display:flex;
align-items:center;
gap:10px;
padding: 16px;
cursor:pointer;
max-height:74px;
overflow:hidden;
background:${({ theme }) => theme.menu.groupContentBackground};
width:100%;
`
const QcName = styled.h1`
color:${({ theme }) => theme.menu.primaryTextColor};
font-size: 20px;
font-weight: 600;
line-height: 30px;

@media(max-width:425px){
    font-size: 18px;
    line-height: 26px;
    text-align:center;
}

`

